import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE002_Request,
  IAPI_PRE002_Response,
  IAPI_REC009_Request,
  IAPI_REC009_Response,
  IAPI_REC014_Request,
  IAPI_REC014_Response,
  IAPI_PRE003_Request,
  IAPI_PRE003_Response,
} from "../../../type/apiType";

// 掛金届出状況詳細表示API
// API仕様書_掛金
const httpAPI_PRE002 = async (
  param: IAPI_PRE002_Request
): Promise<IAPI_PRE002_Response> => {
  let res = await http.post(ApiUrl.API_PRE002, {
    ...param,
  });
  return res.data;
};

// 入金状況更新API
// API仕様書_収納・納付請求処理
const httpAPI_REC009 = async (
  param: IAPI_REC009_Request
): Promise<IAPI_REC009_Response> => {
  let res = await http.post(ApiUrl.API_REC009, {
    ...param,
  });
  return res.data;
};

// 割増金請求状態更新API
// API仕様書_収納・納付請求処理
const httpAPI_REC014 = async (
  param: IAPI_REC014_Request
): Promise<IAPI_REC014_Response> => {
  let res = await http.post(ApiUrl.API_REC014, {
    ...param,
  });
  return res.data;
};

// 掛金詳細コメント更新API
// API仕様書_掛金
const httpAPI_PRE003 = async (
  param: IAPI_PRE003_Request
): Promise<IAPI_PRE003_Response> => {
  let res = await http.post(ApiUrl.API_PRE003, {
    ...param,
  });
  return res.data;
};

export {
  httpAPI_PRE002,
  httpAPI_REC009,
  httpAPI_REC014,
  httpAPI_PRE003,
};
